module.exports = __webpack_public_path__ + "img/type_container-chassis_link.1be70686.jpg";